export enum SSOConfigurationSchema {
  Entra = 'Entra',
  LDAP = 'LDAP',
}

export enum SSOConfigurationType {
  OpenIDConnect = 'OpenIDConnect',
  LDAP = 'LDAP',
}

export type SSOConfiguration = {
  isMock?: boolean;
  scheme: SSOConfigurationSchema;
  displayName: string;
  description: string;
  type: SSOConfigurationType;
  isEnabled: boolean;
  automaticUserCreation: boolean;
  configuration: {
    // LDAP
    host: string;
    port: number;
    useStartTls: boolean;
    bindDn: string;
    bindPassword: string;
    baseDn: string;
    userFilter: string;
    userDnTemplate: string;
    attributes: string[];
    // Microsoft
    authority: string;
    clientId: string;
    clientSecret: string;
    callbackPath: string;
    signedOutCallbackPath: string;
    scopes: string[];
  };
};
